import { useEffect, useState } from 'react';

import { api } from './api';
import type { SocialProvider } from './clerk';

/** GET /v1/auth/config: what the sign-in page offers, and the API address the console gives agents. */
export interface PlaneConfig {
  clerkPublishableKey: string | null;
  socialProviders: SocialProvider[];
  /** https://api.offstage.cloud when the console is on console.offstage.cloud; this page's origin on a plane without one. */
  apiOrigin?: string;
}

let config: Promise<PlaneConfig | null> | undefined;

/** Asked once a page load; null when the plane could not be asked. */
export function planeConfig(): Promise<PlaneConfig | null> {
  config ??= api<PlaneConfig>('/v1/auth/config').then(
    (answer) => answer,
    () => null,
  );
  return config;
}

/** The API address for the snippets and the prompt: this page's origin until the plane names its own. */
export function useApiOrigin(): string {
  const [origin, setOrigin] = useState(window.location.origin);
  useEffect(() => {
    let live = true;
    void planeConfig().then((answer) => {
      if (live && answer?.apiOrigin) setOrigin(answer.apiOrigin);
    });
    return () => {
      live = false;
    };
  }, []);
  return origin;
}
